import { useAtomValue } from 'jotai';
import type { ReactNode } from 'react';

import { providerShortIdAtom } from '../state';
import {
  IntakeSummaryExperimentContext,
  type IntakeSummaryExperimentContextValue,
} from './IntakeSummaryExperimentContext';
import { useIntakeSummaryDelayedExperiment } from './useIntakeSummaryDelayedExperiment';

interface IntakeSummaryExperimentProviderProps {
  children: ReactNode;
}

export function IntakeSummaryExperimentProvider({ children }: IntakeSummaryExperimentProviderProps): ReactNode {
  const providerShortId = useAtomValue(providerShortIdAtom);

  if (!providerShortId) {
    return children;
  }

  return (
    <IntakeSummaryDelayedExperimentProvider providerShortId={providerShortId}>
      {children}
    </IntakeSummaryDelayedExperimentProvider>
  );
}

function IntakeSummaryDelayedExperimentProvider({
  providerShortId,
  children,
}: {
  providerShortId: string;
  children: ReactNode;
}): JSX.Element {
  const { status, experience } = useIntakeSummaryDelayedExperiment(providerShortId);
  const value: IntakeSummaryExperimentContextValue = {
    status,
    experience,
  };

  return <IntakeSummaryExperimentContext.Provider value={value}>{children}</IntakeSummaryExperimentContext.Provider>;
}
